import { collection, getDocs, setDoc, updateDoc, doc, deleteDoc, orderBy, query, where } from 'firebase/firestore';
import { db } from '../../firebase_config';
import { NOTICE_COLLECTION, Notice } from '../../type';

class NoticeService {
  async getAll(): Promise<Notice[]> {
    const q = query(collection(db, NOTICE_COLLECTION), orderBy('createdAt', 'desc'));
    const snapshot = await getDocs(q);

    return snapshot.docs.map(doc => ({ 
      ...doc.data(),
      noticeId: doc.id 
    } as Notice));
  }

  async create(notice: Notice): Promise<void> {
    await setDoc(doc(db, NOTICE_COLLECTION, notice.noticeId), notice);
  }

  async update(noticeId: string, notice: Partial<Notice>): Promise<void> {
    const { noticeId: _, ...noticeData } = notice;
    await updateDoc(doc(db, NOTICE_COLLECTION, noticeId), noticeData);
  }

  async delete(noticeId: string): Promise<void> {
    await deleteDoc(doc(db, NOTICE_COLLECTION, noticeId));
  }
}

export const noticeService = new NoticeService(); 